<template>
  <section
    v-if="shouldRender"
    :id
    class="paragraph-two-columns grid gap-4 tablet:grid-cols-12"
    :class="{
      'container my-spacing-lg': !parentType,
      'is-quarter':
        options.grid === 'quarter' || options.grid === 'quarter_1_3',
      'is-half': options.grid === 'half',
      'min-h-24': isEditing,
    }"
  >
    <BlokkliField
      name="field_paragraphs"
      :list="filterNullArray(paragraphsLeft)"
      :should-render-item
      :class="{
        'tablet:col-span-6': options.grid === 'half',
        'tablet:col-span-8': options.grid === 'quarter',
        'tablet:col-span-4': options.grid === 'quarter_1_3',
      }"
    />
    <BlokkliField
      name="field_paragraphs_box"
      :list="filterNullArray(paragraphsRight)"
      :should-render-item
      class="col-end-[-1]"
      :class="{
        'tablet:col-start-7': options.grid === 'half',
        'tablet:col-start-9': options.grid === 'quarter',
        'tablet:col-start-5': options.grid === 'quarter_1_3',
      }"
    />
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphTwoColumnsFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<ParagraphTwoColumnsFragment>()

const { options, parentType, index, siblings, isEditing } = defineBlokkli({
  bundle: 'two_columns',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    grid: {
      type: 'radios',
      label: 'Widths',
      default: 'half',
      displayAs: 'grid',
      options: {
        half: {
          columns: [1, 1],
          label: 'Half',
        },
        quarter_1_3: {
          columns: [1, 3],
          label: 'Quarter',
        },
        quarter: {
          columns: [3, 1],
          label: 'Quarter',
        },
      },
    },
  },
  editor: {
    disableEdit: true,
  },
})

const id = useParagraphAnchorId(index, siblings)

const { shouldRenderItem } = useParagraphVisiblity()

const shouldRender = computed(
  () =>
    props.paragraphsLeft?.length || props.paragraphsRight?.length || isEditing,
)
</script>
